<template><section><template>
<h3>侧边栏</h3>
<div class="bs-docs-section">
<div class="bs-example">
  <n3-button @click.native="openLeft">左侧栏</n3-button>
  <n3-button @click.native="openRight">右侧栏</n3-button>
  <n3-aside placement="left" title="Title" width="350px" ref="asideLeft">
    <h4>左侧侧边栏</h4>
    <p height="10000px">...</p>
    <p>...</p>
    <p>...</p>
    <n3-button @click.native="closeLeft">关闭</n3-button>
  </n3-aside>
  <n3-aside placement="right" title="Title" width="350px" ref="asideRight" :header="false">
    <h4>右侧侧边栏</h4>
    <p>...</p>
    <p>...</p>
    <p>...</p>
    <n3-button @click.native="closeRight">关闭</n3-button>
  </n3-aside>
</div>
<pre v-pre=""><code v-pre="" class="language-html"><span class="hljs-comment">&lt;!-- 左侧栏 --&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">n3-aside</span>  <span class="hljs-attr">placement</span>=<span class="hljs-string">"left"</span> <span class="hljs-attr">title</span>=<span class="hljs-string">"Title"</span> <span class="hljs-attr">width</span>=<span class="hljs-string">"350px"</span> <span class="hljs-attr">ref</span>=<span class="hljs-string">"asideLeft"</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">h4</span>&gt;</span>左侧侧边栏<span class="hljs-tag">&lt;/<span class="hljs-name">h4</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">p</span>&gt;</span>...<span class="hljs-tag">&lt;/<span class="hljs-name">p</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">p</span>&gt;</span>...<span class="hljs-tag">&lt;/<span class="hljs-name">p</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">p</span>&gt;</span>...<span class="hljs-tag">&lt;/<span class="hljs-name">p</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">n3-button</span> <span class="hljs-attr">@click.native</span>=<span class="hljs-string">"closeLeft"</span>&gt;</span>关闭<span class="hljs-tag">&lt;/<span class="hljs-name">n3-button</span>&gt;</span>
<span class="hljs-tag">&lt;/<span class="hljs-name">n3-aside</span>&gt;</span>

<span class="hljs-comment">&lt;!-- 右侧栏 --&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">n3-aside</span>  <span class="hljs-attr">placement</span>=<span class="hljs-string">"right"</span> <span class="hljs-attr">title</span>=<span class="hljs-string">"Title"</span> <span class="hljs-attr">width</span>=<span class="hljs-string">"350px"</span> <span class="hljs-attr">ref</span>=<span class="hljs-string">"asideRight"</span> <span class="hljs-attr">:header</span>=<span class="hljs-string">"false"</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">h4</span>&gt;</span>右侧侧边栏<span class="hljs-tag">&lt;/<span class="hljs-name">h4</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">p</span>&gt;</span>...<span class="hljs-tag">&lt;/<span class="hljs-name">p</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">p</span>&gt;</span>...<span class="hljs-tag">&lt;/<span class="hljs-name">p</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">p</span>&gt;</span>...<span class="hljs-tag">&lt;/<span class="hljs-name">p</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">n3-button</span> <span class="hljs-attr">@click.native</span>=<span class="hljs-string">"closeRight"</span>&gt;</span>关闭<span class="hljs-tag">&lt;/<span class="hljs-name">n3-button</span>&gt;</span>
<span class="hljs-tag">&lt;/<span class="hljs-name">n3-aside</span>&gt;</span>
</code></pre>
<pre v-pre=""><code v-pre="" class="language-javascript"><span class="hljs-keyword">export</span> <span class="hljs-keyword">default</span> {
  <span class="hljs-attr">methods</span>: {
    openLeft () {
      <span class="hljs-keyword">this</span>.$refs.asideLeft.open()
    },
    openRight () {
      <span class="hljs-keyword">this</span>.$refs.asideRight.open()
    },
    closeLeft () {
      <span class="hljs-keyword">this</span>.$refs.asideLeft.close()
    },
    closeRight () {
      <span class="hljs-keyword">this</span>.$refs.asideRight.close()
    }
  }
}
</code></pre>
<h3>参数</h3>
<table>
<thead>
<tr>
<th>参数名</th>
<th>类型</th>
<th>默认值</th>
<th>说明</th>
</tr>
</thead>
<tbody>
<tr>
<td>placement</td>
<td><code v-pre="">String</code>, 如: <code v-pre="">left</code>, <code v-pre="">right</code></td>
<td><code v-pre="">right</code></td>
<td>组件位置</td>
</tr>
<tr>
<td>title</td>
<td><code v-pre="">String</code></td>
<td></td>
<td>组件头部文本</td>
</tr>
<tr>
<td>header</td>
<td><code v-pre="">Boolean</code></td>
<td></td>
<td>是否需要头部</td>
</tr>
<tr>
<td>width</td>
<td><code v-pre="">String</code></td>
<td></td>
<td></td>
</tr>
</tbody>
</table>
<h3>Events</h3>
<table>
<thead>
<tr>
<th>名称</th>
<th>说明</th>
</tr>
</thead>
<tbody>
<tr>
<td>show</td>
<td>显示</td>
</tr>
<tr>
<td>hide</td>
<td>隐藏</td>
</tr>
</tbody>
</table>
</div>
</template>
</section></template>

<script>
export default {
  methods: {
    openLeft () {
      this.$refs.asideLeft.open()
    },
    openRight () {
      this.$refs.asideRight.open()
    },
    closeLeft () {
      this.$refs.asideLeft.close()
    },
    closeRight () {
      this.$refs.asideRight.close()
    }
  }
}
</script>


// WEBPACK FOOTER //
// n3AsideDocs.md?4e79118c